import type { FetchPagedS3ObjectsQuery, S3ObjectResourceTypeEnum } from '@mbfab/client-api'
import { z } from 'zod'

import type { MillsheetRow } from '../types'

// order-matching/print-types.ts と同じ設計（画面コンポーネントは GraphQL を直接呼ばないため、
// route 側で取得済みの S3Object 情報を props として受け取るだけにする）
export type S3ObjectForPrint = {
  id: string
  imageWidth: number | null
  imageHeight: number | null
  thumbnailFileUrls: string[]
  fileUrl: string
  resourceType: S3ObjectResourceTypeEnum
}

export function toS3ObjectsForPrint(
  s3Objects: FetchPagedS3ObjectsQuery['pagedS3Objects']['s3Objects'],
): S3ObjectForPrint[] {
  return s3Objects.map((s3Object) => ({
    id: s3Object.id,
    imageWidth: s3Object.imageWidth,
    imageHeight: s3Object.imageHeight,
    thumbnailFileUrls: s3Object.thumbnailFileUrls,
    fileUrl: s3Object.fileUrl,
    resourceType: s3Object.resourceType,
  }))
}

// 「印刷」ボタン押下（MillsheetsTable 側）で発火する非同期取得（S3Object のみ。ミルシート本体は
// 選択行としてすでに手元にあるため取り直さない）の結果を props として MillsheetPrintDialog へそのまま渡す
export type PrintDialogState =
  | { status: 'closed' }
  | { status: 'loading' }
  | { status: 'error' }
  | { status: 'ready'; millsheets: MillsheetRow[]; images: S3ObjectForPrint[] }

export const printTargetFlagsSchema = z.object({
  summary: z.boolean(),
  original: z.boolean(),
  // 旧形式（attachments を持たない保存値）のブラウザで設定が既定値に戻らないよう、欠落は ON として読む
  attachments: z.boolean().optional().default(true),
})
export type PrintTargetFlags = z.output<typeof printTargetFlagsSchema>
